import React from "react";
import { SearchIcon, XIcon } from "@heroicons/react/outline";

const SearchBar = ({ 
  placeholder = "Search...", 
  value = "", 
  onChange, 
  onClear,
  className = "",
  size = "md"
}) => {
  const sizeClasses = {
    sm: "py-1 px-3 text-sm",
    md: "py-2 px-4",
    lg: "py-3 px-5 text-lg",
  };

  const handleClear = () => {
    onChange("");
    if (onClear) onClear();
  };

  return (
    <div className={`relative w-full ${className}`}>
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <SearchIcon className="h-5 w-5 text-neutral-dark" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`
          block w-full pl-10 pr-10 
          ${sizeClasses[size]}
          border border-neutral-light dark:border-neutral-dark 
          rounded-lg
          bg-background dark:bg-glass-dark
          text-text dark:text-neutral-light
          placeholder-neutral-dark dark:placeholder-neutral-light
          focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary
          transition-colors duration-200
        `}
        placeholder={placeholder}
      />
      {value && (
        <button
          onClick={handleClear}
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          <XIcon className="h-5 w-5 text-neutral-dark hover:text-text dark:hover:text-neutral-light transition-colors" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
